import type { QuestionData, QuestionModuleData, QuestionModule } from '@/domains/seek/types';

export interface PageDataService {
    buildHttpModulePromise(questionData: QuestionData, module: QuestionModuleData): () => Promise<unknown>;
    buildSseModulePromise(questionData: QuestionData, module: QuestionModuleData): () => Promise<unknown>;
    orderModulesPromiseByPriority(questionData: QuestionData, requestSignal: string, isRegenerate: boolean): [QuestionModuleData[], (() => Promise<unknown>)[][]]
    requestModulesPromise(questionData: QuestionData, modulesPromise: (() => Promise<unknown>)[][]): Promise<void>;
    processAllQuestionModuleData(questionDataList: QuestionData[], requestSignal: string): Promise<QuestionData[]>;
    reProcessPartialQuestionModuleData(questionData: QuestionData, module_names: QuestionModule[], requestSignal: string): Promise<QuestionData[]>;
    terminateSseInstances(): void;
}

export const PageDataService = Symbol('PageDataService');
